module.exports = __webpack_public_path__ + "img/lang_left_btn.09c3ace0.svg";